/** Session key for sign-in screen message after policy-link OTP lockout sign-out. */
export const POLICY_LINK_OTP_LOCKOUT_MESSAGE_KEY = 'club4x4_policy_link_otp_lockout'

export type PolicyLinkOtpApiErrorBody = {
  code?: string
  message?: string
  retryAfterSeconds?: number
  signOutRequired?: boolean
}

export function isPolicyLinkOtpLockoutCode(code?: string): boolean {
  return code === 'OTP_LOCKED' || code === 'POLICY_LINK_OTP_USER_LOCKED'
}

/** True when the API indicates the user must sign out (too many OTP failures). */
export function shouldSignOutForPolicyLinkOtpError(apiBody?: PolicyLinkOtpApiErrorBody): boolean {
  if (!apiBody) return false
  if (apiBody.signOutRequired === true) return true
  return isPolicyLinkOtpLockoutCode(apiBody.code)
}

export function storePolicyLinkOtpLockoutMessage(apiBody?: PolicyLinkOtpApiErrorBody): void {
  const message =
    apiBody?.message ??
    'Too many incorrect verification attempts. You have been signed out. Please try again later or call 1300 296 296.'
  sessionStorage.setItem(POLICY_LINK_OTP_LOCKOUT_MESSAGE_KEY, message)
}

export function consumePolicyLinkOtpLockoutMessage(): string | null {
  const msg = sessionStorage.getItem(POLICY_LINK_OTP_LOCKOUT_MESSAGE_KEY)
  if (msg) sessionStorage.removeItem(POLICY_LINK_OTP_LOCKOUT_MESSAGE_KEY)
  return msg
}
